// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__M9vzz","buttons":"PendingPaymentAlert_buttons__l301S"};